
import React, { Component } from "react";
import { Col, Row, Button, Menu } from "antd";
import { Link } from "react-router-dom";
import logo from "../assets/logo-w.png";
import logoOxxo from "../assets/oxxo.png";
import "../styles/Footer.css";
import { doLogout } from "../redux/actions/Session";
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import insta from "../assets/ins.png";
import face from "../assets/fb.png";
import lin from "../assets/link.png";
import twtt from "../assets/twtt.png";

class Footer extends Component {
    constructor(props) {
        super(props)
    }

    isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    };

    render() {
        const isMobile = this.isMobileDevice();
        return (
            <div>
                {isMobile ?
                    <footer style={{ width: '100%', display: 'inline-block' }}>
                        <Row style={{ width: '100%' }}>
                            <Row span={24} >
                                <Col span={24} style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
                                    <img className="img-footer" src={logo} height="24px" alt="" />
                                    <img className="img-footer" src={logoOxxo} height="24px" alt="" />
                                </Col>
                            </Row>
                            <br />
                            <Row style={{ width: '100%', textAlign: 'center' }} >
                                <Col span={24} >
                                    <a href="https://instagram.com/wheelingmob" target="_blank"><img className="img-footer" src={insta} height="15px" alt="" /></a>
                                    <a href="https://www.facebook.com/wheelingmob/" target="_blank"><img className="img-footer" src={face} height="15px" alt="" /></a>
                                    <a href="/" ><img className="img-footer" src={lin} height="15px" alt="" /></a>
                                    <a href="https://www.twitter.com/wheelingmob/" target="_blank"><img className="img-footer" src={twtt} height="15px" alt="" /></a>
                                </Col>
                            </Row>
                        </Row>
                        <br />
                        <Row style={{ width: '100%' }}>
                            <Col span={24} style={{ display: "flex", justifyContent: "space-around", alignContent: "center" }}>
                                <div className="footer-text"><a href="https://wheelingmobility.com/" target="_blank">Wheeling Movility. </a><a href="https://wheelingmobility.com/aviso-de-privacidad/" target="_blank">Aviso de privacidad.</a>  <a href="https://wheelingmobility.com/wp-content/uploads/2019/06/terminos-y-condiciones-wheeling.pdf" target="_blank">Términos y condiciones</a></div>
                            </Col>
                        </Row>
                    </footer>
                    :
                    <footer>
                        <Col span={6} style={{ display: "flex", justifyContent: "space-around", alignContent: "center" }}>
                            <img className="img-footer" src={logo} height="24px" alt="" />
                            <img className="img-footer" src={logoOxxo} height="24px" alt="" />
                        </Col>
                        <Col span={14}>
                            <div className="footer-text"><a href="https://wheelingmobility.com/" target="_blank">Wheeling Movility. </a><a href="https://wheelingmobility.com/aviso-de-privacidad/" target="_blank">Aviso de privacidad.</a>  <a href="https://wheelingmobility.com/wp-content/uploads/2019/06/terminos-y-condiciones-wheeling.pdf" target="_blank">Términos y condiciones</a></div>
                        </Col>
                        <Col span={4} style={{ display: "flex", justifyContent: "space-around", alignContent: "center" }}>
                            <a href="https://instagram.com/wheelingmob" target="_blank"><img className="img-footer" src={insta} height="15px" alt="" /></a>
                            <a href="https://www.facebook.com/wheelingmob/" target="_blank"><img className="img-footer" src={face} height="15px" alt="" /></a>
                            <a href="/" ><img className="img-footer" src={lin} height="15px" alt="" /></a>
                            <a href="https://www.twitter.com/wheelingmob/" target="_blank"><img className="img-footer" src={twtt} height="15px" alt="" /></a>
                        </Col>
                    </footer>
                }
            </div>
        )
    }
}
const mapStateToProps = state => {
    return { session: state.session.user }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ doLogout }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer)